import React from 'react';
import Image403 from "../../images/Image403.webp"
import { useNavigate } from 'react-router-dom';
import './AccessDenied.css';
import { Button, Box } from '@mui/material';


const AccessDenied = () => {
  const navigate = useNavigate();
  const isLoggedIn = Boolean(localStorage.getItem("userId"));


  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <main className="access-denied">
      <div className="access-denied__content">

        {/* Image */}
        <Box>
          <img src={Image403} alt="AccessDeniedImage" className='access-denied__image' />
        </Box>
        {/* Text */}
        <div className="access-denied__text">
          <p>
            You do not have permission to view this page.
            If you believe this is an error, please contact your system administrator.
          </p>
        </div>

        {/* Actions */}
        <div className="access-denied__actions">
          <button
            className="access-btn access-btn--primary"
            onClick={handleGoBack}
          >
            <span>←</span>
            Go Back
          </button>

          {isLoggedIn ? (
            <Button onClick={() => navigate("/dashboard")}>
              Go to Dashboard
            </Button>
          ) : (
            <Button onClick={() => navigate("/login")} sx={{ p: 1, borderRadius: "10px" }}>
              Go to Login
            </Button>
          )}
        </div>

      </div>
    </main>
  );
};

export default AccessDenied;